import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import React, { useState } from 'react';
import FormInput from 'partial/form/FormInput';
import Button from 'partial/components/Button';
import Form, { ErrorLabel } from 'partial/form/Form';
import { useCreateChannelBranch, useUpdateChannelBranch } from '../hooks';
import { transformChannelBranch } from '../transformers';

function ChannelBranchModal({ closeModal, data }) {
  const isNew = isUndefined(data?.id);
  const [form, setForm] = useState(data);
  const [isCreating, create] = useCreateChannelBranch();
  const [isUpdating, update] = useUpdateChannelBranch();

  const handleSubmit = () => {
    if (isNew) {
      create(form, () => {
        closeModal();
      });
      return;
    }
    update(data?.id, form, () => {
      closeModal();
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className="mb-3">
        <FormInput
          name="name"
          onChange={setForm}
          value={form.name}
          label="Name"
          type="text"
          required
        />
        <ErrorLabel name="email" />
      </div>
      <div className="flex">
        <Button
          className="mr-2"
          onClick={closeModal}
          disabled={isCreating || isUpdating}
        >
          Close
        </Button>
        <Button primary type="submit" disabled={isCreating || isUpdating}>
          Save
        </Button>
      </div>
    </Form>
  );
}

ChannelBranchModal.defaultProps = {
  data: transformChannelBranch,
};

ChannelBranchModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Object),
};

export default ChannelBranchModal;
